import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { TransactionProvider } from "@/contexts/TransactionContext";
import { DragProvider } from "@/contexts/DragContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import { ToastProvider } from "@heroui/react";
import { publicRoutes, RoleBasedRoutes } from "@/routes/RoleBasedRoutes";
import GuardedRoute from "@/components/auth/GuardedRoute";

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AuthProvider>
        <LanguageProvider>
          <TransactionProvider>
            <DragProvider>
              <MantineProvider>
              <ToastProvider placement="top-right" />
              <Routes>
                {/* Public Routes */}
                {publicRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                  />
                ))}

                {/* Role-based Protected Routes */}
                {RoleBasedRoutes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      <GuardedRoute path={route.path} roles={route.roles} />
                    }
                  />
                ))}
              </Routes>
              </MantineProvider>
            </DragProvider>
          </TransactionProvider>
        </LanguageProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
